module.exports = __webpack_public_path__ + "static/media/hacobell-brand-foreground-white.3177648c.svg";